import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SportsLandingPage from './SportsLandingPage';
import Register from './Register';
import Login from './Login'; 
import './App.css';
import { AuthProvider} from './context/AuthContext';
import Dashboard from './pages/dashboard';
import PrivateRoute from './components/PrivateRoute';
import ViewGrounds from './pages/ViewGrounds';
import CreateGround from './pages/CreateGround';
import ViewSchedule from './pages/ViewSchedule';
import CreateSchedule from './pages/CreateSchedule';
import DeleteSchedule from './pages/DeleteSchedule';
import AccountSettings from './pages/AccountSettings';
import PrivacyPolicy from './legal/PrivacyPolicy';
import TermsOfService from './legal/TermsOfService';
import ResetPassword from './components/ResetPassword';

const App = () => {
  // Suppose your AuthContext provides this hook to get auth status 

  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<SportsLandingPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/ResetPassword" element={<ResetPassword />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        {/* Protected route wrapped with PrivateRoute */}
        <Route 
          path="/dashboard" 
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } 
        />
      <Route 
    path="/ViewGrounds" 
    element={
      <PrivateRoute>
        <ViewGrounds />
      </PrivateRoute>
    } 
  />
    <Route 
    path="/CreateGround" 
    element={
      <PrivateRoute>
        <CreateGround />
      </PrivateRoute>
    } 
  />
    <Route 
    path="/ViewSchedule" 
    element={
      <PrivateRoute>
        <ViewSchedule />
      </PrivateRoute>
    } 
  />
    <Route 
    path="/CreateSchedule" 
    element={
      <PrivateRoute>
        <CreateSchedule />
      </PrivateRoute>
    } 
  />
  <Route 
    path="/DeleteSchedule" 
    element={
      <PrivateRoute>
        <DeleteSchedule />
      </PrivateRoute>
    } 
  />
  <Route 
    path="/AccountSettings" 
    element={
      <PrivateRoute>
        <AccountSettings />
      </PrivateRoute>
    } 
  />
      </Routes>
    </AuthProvider>
  );
};

export default App;
